import { useAuth } from '@auth/use-auth'
import { PageFallback } from '@components/page-fallback'
import { isInIframe } from '@utils/is-in-iframe'
import { useLocation, Navigate } from 'react-router-dom'

export const RequireAuth = ({ children }) => {
  const { initialized, userName, loading } = useAuth()
  const location = useLocation()

  if (!initialized && loading) {
    return <PageFallback />
  }

  if (initialized && userName) {
    return children
  }

  return (
    <Navigate
      to={isInIframe ? '/not-available' : '/signin'}
      state={{ from: location }}
      replace
    />
  )
}
